import { render } from "./wechat_h5_wechat_official_account.vue?vue&type=template&id=3e439e4a"
import script from "./wechat_h5_wechat_official_account.vue?vue&type=script&lang=js"
export * from "./wechat_h5_wechat_official_account.vue?vue&type=script&lang=js"

import exportComponent from "/vuebuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__